import UserSingleSelect from "@/components/form/user-single-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import { UserRole } from "@/types/openapi-enum";

/** The typical "assignable user" pool. */
const DEFAULT_ASSIGNEE_ROLES = [
  UserRole.Manager,
  UserRole.Coordinator,
  UserRole.Technician,
  UserRole.Evaluator,
];

type AssigneeFieldExtraProps = {
  /** Role filter. Defaults to `[Manager, Coordinator, Technician, Evaluator]`; narrow it (e.g. `[Technician]`) per screen. */
  roles?: UserRole[];
  /** Scopes the pool to users belonging to this account. Unset = all accounts. */
  accountId?: string;
  placeholder?: string;
  align?: "start" | "center" | "end";
};

export type AssigneeFieldProps = PickerFieldProps<
  string | null,
  AssigneeFieldExtraProps
>;

/** Searchable single-user picker. **Value is a user id** (`string | null`). */
export const AssigneeField = makePickerField<
  string | null,
  AssigneeFieldExtraProps
>({
  name: "AssigneeField",
  control: UserSingleSelect,
  popout: true,
  controlProps: (props) => ({
    params: {
      roles: (props.roles ?? DEFAULT_ASSIGNEE_ROLES).join(","),
      isActivated: "true",
      ...(props.accountId ? { accountId: props.accountId } : {}),
    },
    showAccountName: true,
    placeholder: props.placeholder,
    align: props.align,
  }),
});
